import { Button, createTheme, ThemeProvider } from '@mui/material';
import cn from 'classnames';
import React, { useEffect, useState } from 'react';
import styles from './MemebrshipClub.module.scss';
// import { useRouter } from 'next/router';
// import { BCBreadcrumbs } from '../index';
import { useSelector } from 'react-redux';
// import ScrollableContent from '../ScrollableContent/ScrollableContent';
import dynamic from 'next/dynamic';
import InView from 'react-intersection-observer';
// import { httpGet } from '../../utils/httpClient';
// import { useWindowWidth } from '@react-hook/window-size';
// import Logo from '../../public/logo.svg';
// import CurrencyFormat from 'react-currency-format';
// import getSymbolFromCurrency from 'currency-symbol-map';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Divider from '@mui/material/Divider';
import ListItemText from '@mui/material/ListItemText';
// import ListItemAvatar from '@mui/material/ListItemAvatar';
// import Avatar from '@mui/material/Avatar';
// import Typography from '@mui/material/Typography';
// import CheckIcon from '@mui/icons-material/Check';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
// import Image from 'next/image';
// import { DealsCarousel } from '../DealsPage/DealsCarousel/DealsCarousel';
import { membershipClubFAQs, howClubWorksDeals, howClubWorksNoDeals, dealsItems } from './text-configs';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { checkUserCountry } from '../../utils/checkUserCountry';

const CallToSignUp = dynamic(() => import('../CallToSignUp/CallToSignUp'));
const ScrollableContent = dynamic(() =>
  import('../ScrollableContent/ScrollableContent')
);

const theme = createTheme({
  palette: {
    primary: {
      main: '#ffffff',
    },
    secondary: {
      main: '#0a0a0a',
    },
  },
  typography: {
    fontFamily: '"Libre Franklin", sans-serif',
  },
});

// const getRegionOffers = async (filterObj) => {
//   let filterUrl = '';
//   Object.keys(filterObj).forEach((key) => {
//     if (filterObj[key]) {
//       filterUrl += `&${key}=${filterObj[key]}`;
//     }
//   });

//   if (filterUrl.charAt(0) === '&') {
//     filterUrl = filterUrl.slice(1);
//   }

//   const regionOffersRes = await httpGet(
//     `/api/flight/region/offers?${filterUrl}&size=100`
//   );

//   return await regionOffersRes.json();
// };

// const getFeaturedOrigins = async (country) => {
//   const featuredFlightsDealsRes = await httpGet(
//     `/api/flight/popular/origin?country=${country}&cabinClass=BIZ`
//   );

//   return await featuredFlightsDealsRes.json();
// };

export function MembershipClub({ authCompleted, setLoginDialogState }) {
  // const router = useRouter();
  const [FAQList, setFAQList] = useState(membershipClubFAQs);
  const [howClubWorksList, setHowClubWorksList] = useState(howClubWorksDeals);
  // const width = useWindowWidth();
  // const [regionalDeals, setRegionalDeals] = useState(null);
  // const [featuredOrigin, setFeaturedOrigin] = useState(null);
  // const [currentRegionIndex, setCurrentRegionIndex] = useState(0);

  const userStore = useSelector((state) => state.user.value);

  useEffect(() => {
    if (userStore) {
      // getFeaturedOrigins(userStore.country).then((res) => {
      //   const featuredOrigin = { ...res, selectedOrigin: res.origin?.[0] };
      //   setFeaturedOrigin(featuredOrigin);
      // });

      if (!checkUserCountry(userStore.country)) {
        const filteredFAQs = membershipClubFAQs.filter((faq) => faq.isDealsMarket !== true);
        setFAQList(filteredFAQs);
        setHowClubWorksList(howClubWorksNoDeals);
      } else {
        setFAQList(membershipClubFAQs);
        setHowClubWorksList(howClubWorksDeals);
      }
    }
  }, [userStore]);

  // useEffect(() => {
  //   if (featuredOrigin?.origin && checkUserCountry(userStore?.country)) {
  //     const filterObj = {
  //       country: userStore.country,
  //       currency: userStore.currency,
  //       origin: featuredOrigin?.selectedOrigin,
  //       cabinClass: 'BIZ',
  //     };

  //     getRegionOffers(filterObj).then((offersRes) => {
  //       if (!offersRes.offers) {
  //         setRegionalDeals({ offersByRegion: null });
  //         return;
  //       }
  //       const offersByRegion = offersRes.offers?.reduce((acc, offer) => {
  //         if (!acc[offer.region]) {
  //           acc[offer.region] = [];
  //         }
  //         acc[offer.region].push(offer);
  //         return acc;
  //       }, {});

  //       for (const region in offersByRegion) {
  //         offersByRegion[region].sort((a, b) => {
  //           return a.price - b.price;
  //         });
  //       }

  //       const sortedRegions = Object.keys(offersByRegion).sort((a, b) => {
  //         return offersByRegion[b].length - offersByRegion[a].length;
  //       });

  //       const sortedRegionOffers = {};
  //       sortedRegions.forEach((region) => {
  //         sortedRegionOffers[region] = offersByRegion[region];
  //       });

  //       const regionOffers = {
  //         ...offersRes,
  //         offersByRegion: sortedRegionOffers,
  //       };
  //       console.log(regionOffers);
  //       setRegionalDeals({ ...regionOffers });
  //     });
  //   }
  // }, [featuredOrigin]);

  // useEffect(() => {
  //   if (!regionalDeals?.offersByRegion) return;
  //   const interval = setInterval(() => {
  //     setCurrentRegionIndex(
  //       (prevIndex) =>
  //         (prevIndex + 1) % Object.keys(regionalDeals?.offersByRegion).length
  //     );
  //   }, 5000);

  //   return () => clearInterval(interval);
  // }, [regionalDeals]);

  const CTAButton = (isLightMode) => {
    return(
      <>
        {userStore && !userStore.userid && (
          <Button
            className={cn(
              styles.ctaButton,
            )}
            sx={{
              fontSize: '1rem',
              textTransform: 'unset',
              backgroundColor: '#d4a976',
              width: '225px',
              borderRadius: '10px',
              textAlign: 'center',
              textOrientation: 'none',
            }}
            onClick={() => setLoginDialogState({ opened: true, state: 'signUp', sourcePage: 'Membership Club Top' })}
          >
            Sign up for free
          </Button>
        )}

        {userStore && userStore.userid && (
          <span className='text-white text-lg'>
            <CheckCircleOutlineIcon sx={{ color: '#4db060', fontSize: '30px' }}/> <span className={isLightMode ? 'text-black': 'text-white'}>Congrats! You are already a club member</span>
          </span>
        )}
        
      </>
    )
  }

  return (
    <ThemeProvider theme={theme}>
      <div className={cn(styles.topSection)}>
        <div className={cn(styles.topSectionContainer, 'px-4 lg:px-6 py-2')}>
          {!checkUserCountry(userStore?.country) && userStore?.userid && (
            <div className="my-10">
              <h1 className={cn(styles.topSectionText, 'font-libre')}>
                Welcome to <b>The Club</b>
              </h1>
            </div>
          )}


          <div>
            <h1 className={cn(styles.topSectionText, 'font-libre')}>
              <span className={styles.highlighted}>Save Big</span> on Premium Flights and Hotels
            </h1>

            <p className={cn(styles.subheader, 'mb-10')}>
              Join for free to get exclusive member-only rates and instant travel savings.
            </p>

            {CTAButton()}
          </div>

        </div>

        {/* {userStore && !userStore.userid && (
          <InView triggerOnce>
            {({ inView, ref }) => (
              <div
                ref={ref}
                className={cn(
                  styles.callToSignUpContainer,
                  'w-full mx-auto relative'
                )}
              >
                {inView && (
                  <CallToSignUp
                    country={userStore?.country}
                    customHeading={<><p>Unlock Big Savings on Every Premium flight and Hotel Booking</p><span className='text-2xl'>FREE to join. Get deals in seconds. Sign up now!</span></>}
                    authCompleted={authCompleted}
                    isCutomBackground={true}
                    sourcePage={'Membership Club Top'}
                    isDealsTextShown={false}
                    customOverline={
                      <h1 className={cn(styles.topSectionText)}>
                        Welcome to <b className="font-libre">The Club</b>
                      </h1>
                    }
                  />
                )}

                  <div className='sm:w-full w-1/2 m-auto text-center pb-5'>
                    <span className="font-libre text-xl text-white">
                      Already a member? {' '}
                      <span className='underline cursor-pointer' onClick={() => setLoginDialogState({opened: true, state: 'login', sourcePage: 'Memebership Club login'})}>Log in here</span>
                    </span>
                  </div>
              </div>
            )}
          </InView>
        )} */}

        {/* {checkUserCountry(userStore?.country) &&
          regionalDeals?.offersByRegion &&
          userStore?.userid && (
            <div className={cn(styles.regionContentWrapper)}>
              <div className="flex flex-col lg:flex-row container mx-auto">
                <div className="p-8 sm:p-2 w-full">
                  <h1 className={cn(styles.topSectionText)}>
                    Welcome to <b className="font-libre">The Club</b>
                  </h1>
                  <div
                    className={cn(
                      styles.regionContent,
                      'grid lg:grid-cols-2 gap-4 w-full'
                    )}
                  >
                    {Object.keys(regionalDeals.offersByRegion).map(
                      (region, index) => (
                        <div
                          key={region + index}
                          style={{
                            display:
                              index === currentRegionIndex ||
                              (width > 1024 &&
                                (index === currentRegionIndex + 1 ||
                                  (index === 0 &&
                                    currentRegionIndex ===
                                      Object.keys(regionalDeals.offersByRegion)
                                        .length -
                                        1)))
                                ? 'block'
                                : 'none',
                          }}
                        >
                          <h3 className={styles.regionTitle}>
                            <span className="inline-block">
                              Business Class deals{' '}
                            </span>{' '}
                            <span className="break-keep inline-block">
                              {' '}
                              to {region}
                            </span>
                          </h3>
                          {regionalDeals?.offersByRegion[region].map(
                            (offer) => (
                              <a
                                key={
                                  offer.destination +
                                  offer.airline +
                                  offer.price
                                }
                                className={cn(styles.regionItem)}
                                href={
                                  '/?origin=' +
                                  offer.origin +
                                  '&destination=' +
                                  offer.destination +
                                  '&cabinClass=' +
                                  offer.cabinClass
                                }
                              >
                                <div
                                  className={styles.regionName}
                                  title={offer.destination}
                                >
                                  {regionalDeals.city[offer.destination]}
                                </div>
                                <div className={styles.regionImage}>
                                  {regionalDeals.airlines[offer.airline]}
                                </div>
                                <div className={styles.regionPrice}>
                                  <div>
                                    From{' '}
                                    <CurrencyFormat
                                      thousandSeparator
                                      displayType={'text'}
                                      prefix={
                                        getSymbolFromCurrency(
                                          userStore.currency
                                        ) + ' '
                                      }
                                      value={Math.round(offer.price)}
                                    />
                                  </div>
                                </div>
                              </a>
                            )
                          )}
                        </div>
                      )
                    )}
                  </div>

                  <a
                    className={cn(
                      styles.showDealsButton,
                      'text-white font-serif mx-auto lg:mt-8 sm:mt-2'
                    )}
                    href="/"
                  >
                    Show me
                  </a>
                </div>
              </div>
            </div>
          )} */}
      </div>

      <div className={cn(styles.whyJoinContainer)}>
        <div className='container'>
          <h2 className="w-full font-fragment text-center">The Secret to the Best Premium Deals?</h2>
          <div className='mx-auto'>
            <div className="grid grid-cols-3 sm:grid-cols-1 gap-6 text-center">
              {dealsItems.map((column, index) => (
                <div key={index} className="flex flex-col items-center">
                  {column.icon}
                  <p className={cn(styles.highlightWord, 'text-xl font-bold')}>{column.title}</p>
                  <p>{column.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className={styles.content}>
        <div className="section">
          <h2 className="font-fragment w-full">
            How The Club works
          </h2>

          <List
            sx={{
              width: '100%',
              bgcolor: 'transparent',
              marginLeft: '0',
            }}
            className={cn(styles.list, 'grid lg:grid-cols-2 gap-4')}
          >
            {howClubWorksList.map((item, index) => (
              <div key={index}>
                <ListItem alignItems="flex-start" sx={{
                  backgroundColor: '#FAF8F4',
                  minHeight: '100px',
                }}>
                  {/* <ListItemAvatar>
                    <Avatar sx={{ bgcolor: '#3C6562' }}>
                      <CheckIcon sx={{ color: '#FFF' }} />
                    </Avatar>
                  </ListItemAvatar> */}
                  <ListItemText
                    primary={<b>{item.heading}</b>}
                    secondary={<span>{item.content}</span>}
                  />
                </ListItem>
                {index !== howClubWorksList.length - 1 && (
                  <Divider
                    variant="inset"
                    component="li"
                    className="list-none"
                  />
                )}
              </div>
            ))}
          </List>

          <div className='my-3 text-center'>
            {CTAButton()}
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1">
        {/* <div className={styles.benefitsImage}>
          <h2 className="font-fragment w-full text-white">Member benefits</h2>
        </div> */}
        <div className={cn(styles.benefits, 'py-12')}>
          <h2 className="font-fragment w-full text-white">Member benefits</h2>
{/* 
          <h3 className="mb-10">
            Join First-Class.com - The Club today and start enjoying these
            exclusive benefits!
          </h3> */}

          <ul className='grid lg:grid-cols-2 gap-x-5 gap-y-2'>
            <li>
              <TaskAltIcon /> Book member-only fares
            </li>
            <li>
              <TaskAltIcon /> Great savings on flights & hotels
            </li>
            {/* {checkUserCountry(userStore?.country) && ( */}
              <li>
                <TaskAltIcon /> Receive deal alerts
              </li>
            {/* )} */}
            {/* {checkUserCountry(userStore?.country) && (
              <li>
                <TaskAltIcon /> Exclusive access to FlightDeals
              </li>
            )} */}
            <li>
              <TaskAltIcon /> Add destinations in MapMyTravel
            </li>
            <li>
              <TaskAltIcon /> Exclusive Offers & Events
            </li>
            <li>
              <TaskAltIcon /> Premium member-only travel content
            </li>
          </ul>
        </div>
      </div>

      {/* <div className={styles.dealsAlerts}>
        <div className='container'>
          <h2 className='font-fragment mt-5'>Deals our members booked</h2>
          <div className={styles.dealsCarousel}>
            <DealsCarousel>
              {dealsCarouselItems.map((item, index) => (
                <div key={index} className={cn(styles.dealsCarouselItem)}>
                  <div className={styles.dealImage}>
                    <Image
                      src={ process.env.mediaUrl + item.image.replace('/', '') }
                      alt="Destination image"
                      width={620}
                      height={350}
                      layout={'responsive'}
                      objectFit={'contain'}
                      placeholder={'blur'}
                      blurDataURL={process.env.mediaUrl + item.image.replace('/', '')}
                      quality={75}
                      priority
                      >
                    </Image>
                  </div>
                  <div className={styles.dealData}>
                    <h3>
                      <CurrencyFormat
                        thousandSeparator
                        displayType={'text'}
                        prefix={
                          getSymbolFromCurrency(item.currency) +
                          ' '
                        }
                        value={Math.round(item.price)}
                      />
                    </h3>
                    <div>(<b>20% off</b> normally {+item.price * 1.2 })</div>
                    <p>{item.origin} - {item.destination}</p>
                  </div>
                  
                </div>
              ))}
            </DealsCarousel>
          </div>

          <div className='mt-10 text-center'>
            {CTAButton(true)}
          </div>
        </div>
      </div> */}

      <div className="container flex flex-col justify-center items-center sm:w-full mb-8 sm:px-4">
        <span className={cn(styles.listTitle, 'text-3xl font-fragment my-6')}>
          FAQs
        </span>
        {FAQList.map((faq, index) => (
          <ScrollableContent
            key={index}
            heading={faq.heading}
            content={faq.content}
            style={styles.scrollableContent}
          />
        ))}
      </div>

      {userStore && !userStore.userid && (
        <InView triggerOnce>
          {({ inView, ref }) => (
            <div ref={ref} className="w-full mx-auto">
              {inView && (
                <CallToSignUp
                  customHeading={'Join First-Class.com The Club'}
                  country={userStore?.country}
                  authCompleted={authCompleted}
                  sourcePage={'Membership Club bottom'}
                />
              )}
            </div>
          )}
        </InView>
      )}
    </ThemeProvider>
  );
}
